import { useState, useEffect } from 'preact/hooks';
import { useIsMounted } from '@/hooks';
import iconMap from '@/assets/icons/icons.json';
import api from '@/api';
import { useFormProps, useConfigStore } from '../stores/ConfigStore';

export default function SvgIcon({
	icon = '',
	customIcon,
	className = '',
	style,
	...props
}) {
	const { icons } = useConfigStore();

	const iconName = String(icon).replace('fa-', '').replace('fa ', '');

	const iconData = iconMap[iconName] ?? icons[iconName];

	if (customIcon) {
		return (
			<Icon
				name={customIcon.uuid}
				icon={customIcon}
				className={className}
				style={style}
				{...props}
			/>
		);
	}

	if (iconData) {
		return (
			<Icon
				name={iconName}
				icon={iconData}
				className={className}
				style={style}
				{...props}
			/>
		);
	}

	return (
		<FetchIcon
			name={iconName}
			className={className}
			style={style}
			{...props}
		/>
	);
}

function Icon({ name, icon = {}, className = '', style, ...props }) {
	const { alt, ...rest } = props;
	return (
		<i
			className={`mopicon mopicon-${name} ${className}`}
			// aria-hidden={true}
			role="none"
			style={style}
			{...rest}
		>
			<svg
				viewBox={icon.viewBox || '0 0 28 28'}
				role={alt ? 'img' : 'presentation'}
				{...(!alt && { 'aria-hidden': 'true' })}
			>
				{alt && <title>{alt}</title>}
				<path
					d={icon.path || ''}
					fill="currentColor"
				/>
			</svg>
		</i>
	);
}

function FetchIcon({ name, className, style, ...props }) {
	const { domain, cacheDomain, customDomain } = useFormProps();
	const [icon, setIcon] = useState({});
	const isMounted = useIsMounted();
	useEffect(() => {
		api({ domain, cacheDomain, customDomain })
			.getIcons(name)
			.then(response => {
				if (isMounted) {
					const parsed = typeof response === 'string' ? JSON.parse(response) : response;

					iconMap[name] = parsed[name];
					setIcon(parsed[name]);
				}
			});
	}, []);

	return (
		<Icon
			icon={icon}
			className={className}
			style={style}
			{...props}
		/>
	);
}
